/* eslint-disable vue/no-v-html */
<template>
  <div class="tags__tag" @click="onRemove(name)">
    <div class="content">
      <span class="name">{{ name + ": " }}</span>
      <div
        v-tooltip="contentTooltip"
        class="value"
        v-html="contentFormatted"></div>
    </div>
    <div class="close-icon">
      <span class="mi-20px mi-times" aria-hidden="true"> </span>
    </div>
  </div>
</template>

<script>
import { format, addDays, subDays, startOfToday } from "date-fns";
import { isObject, isEmpty } from "@/utils/helpers";

export default {
  name: "FilterTag",
  props: {
    name: {
      type: String,
      default: "",
    },
    tag: {
      type: [String, Object, Array],
      required: true,
    },
  },
  computed: {
    contentFormatted() {
      let content =
        isObject(this.tag) && !isEmpty(this.tag)
          ? this.tag.employeeId
          : Array.isArray(this.tag)
          ? typeof this.tag[0] === "boolean"
            ? this.tag.length == 2
              ? "Yes or No"
              : this.tag[0]
              ? "Yes"
              : "No"
            : this.tag.length > 1
            ? this.tag.length > 5
              ? `${
                  this.tag[0]
                } + <span style='font-family:"Maersk Text"; font-weight: normal;'>${
                  this.tag.length - 1
                } more items </span>`
              : this.tag.join("<span> (or) </span>")
            : this.tag[0]
          : this.tag;

      if (this.tag.type === "RANGE" && (this.tag.from || this.tag.to)) {
        content = `${format(new Date(this.tag.from), "dd-MMM-yyyy")} ${
          this.tag.to
            ? `<span> (to) </span> ${format(
                new Date(this.tag.to),
                "dd-MMM-yyyy"
              )}`
            : ""
        }`;
      } else if (this.tag.type === "RELATIVE_DATE_RANGE") {
        const relativeDate = startOfToday();

        const fromDayFormatted =
          typeof this.tag.from_days === "number"
            ? this.tag.from_days === 0
              ? startOfToday()
              : this.tag.from_days >= 1
              ? addDays(relativeDate, this.tag.from_days)
              : subDays(relativeDate, Math.abs(this.tag.from_days))
            : null;
        const toDayFormatted =
          typeof this.tag.to_days === "number"
            ? this.tag.to_days === 0
              ? startOfToday()
              : this.tag.to_days >= 1
              ? addDays(relativeDate, this.tag.to_days)
              : subDays(relativeDate, Math.abs(this.tag.to_days))
            : null;

        content = `${format(fromDayFormatted, "dd-MMM-yyyy")} ${
          toDayFormatted
            ? `<span> (to) </span> ${format(toDayFormatted, "dd-MMM-yyyy")}`
            : ""
        }`;
      }
      return content;
    },
    contentTooltip() {
      let content =
        Array.isArray(this.tag) && this.tag.length > 5
          ? this.tag.join("<span> (or) </span>")
          : "";
      return content;
    },
  },
  methods: {
    onRemove(name) {
      this.$emit("onRemoveFilter", name);
    },
  },
};
</script>

<style lang="scss" scoped>
.tags__tag {
  cursor: pointer;
  display: flex;
  align-items: center;
  & .content {
    // padding: 4px 8px;
    // border-right: 1px solid var(--tab-border);

    & .name {
      font-size: 14px;
      color: var(--primary-text);
      font-family: "Maersk Text";
    }
    & .value {
      display: inline-block;
      font-size: 14px;
      color: var(--primary-text);
      font-family: "Maersk Text Bold";
      font-weight: bold;
    }
  }
  & .close-icon {
    // margin: 0 8px;
    cursor: pointer;
    display: flex;
    fill: var(--icon-bg);
    stroke: var(--icon-bg);
  }
}
</style>
